"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubscriptionSignatureType = void 0;
exports.ESubscriptionSignatureType = {
    rto: "rto",
    subscription: "subscription",
    management_company: "management_company",
};
